(ns portal.user-management-page.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.flags :refer [use-flag]]
            [common.widgets.page :as page]
            [common.widgets.panel :refer [panel]]
            [common.widgets.table :as t]
            [linked.core :as l]
            [portal.role-table.view :as role-table]
            [portal.user-table.view :as user-table]
            [portal.v2-user-table.view :as v2-user-table]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [defui $]]))

(defui roles []
  ($ panel {:title "Roles"
            :actions ($ Button
                        {:on-click #(rf/dispatch [:ocp/open {:id :role/crud}])
                         :variant "contained"
                         :data-testid "add-role-button"}
                        "Add role")
            :footer ($ role-table/pages)
            :table-content? true}
     ($ t/table-actions
        ($ role-table/filter-input))
     (r/as-element [role-table/table])))

(defui user-management-page []
  (let [v2-users? (use-flag :user-management-v-2)
        tabs (uix/use-memo
              (fn []
                (cond-> (l/map :users {:label "Users"
                                       :view user-table/user-data-grid
                                       :container-sx #js {:overflow "hidden"}}
                               :roles {:label "Roles"
                                       :view roles})
                  v2-users? (assoc :v2-users {:label "V2 Users"
                                              :view v2-user-table/v2-user-data-grid
                                              :container-sx #js {:overflow "hidden"}})))
              [v2-users?])]
    (uix/use-effect (fn []
                      (rf/dispatch [:role-table.db/init]))
                    [])
    ($ page/page
       ($ page/page-header
          {:title "User management"
           :tabs tabs})
       ($ page/active-tab
          {:tabs tabs}))))
